import { createAction, props } from '@ngrx/store';
import { IOnlineUseData, IOnlineUseModel } from '@partners/api';

export class OnlineUseActions {
  static reset = createAction('[OnlineUse] Reset State');
  static load = createAction('[OnlineUse] Load');
  static loadSuccess = createAction(
    '[OnlineUse] Load Success',
    props<{ model: IOnlineUseModel; data: IOnlineUseData }>()
  );
  static loadFailure = createAction('[OnlineUse] Load Failure', props<{ error: any }>());
  static submit = createAction('[OnlineUse] Submit', props<{ model: IOnlineUseModel }>());
  static submitSuccess = createAction('[OnlineUse] Submit Success', props<{ data: IOnlineUseData }>());
  static submitFailure = createAction('[OnlineUse] Submit Failure', props<{ error: any }>());
}
